<template>
    <div>
        <b-row class="customer-search-row mb-2">
            <b-col cols="12" sm="12" md="5" class="mb-3 mb-md-0">
                <h3 class="page-title">Customer Management</h3>
            </b-col>
            <b-col cols="12" sm="6" md="3" class="mb-3 mb-md-0 ml-md-auto customer-field-col">
                <eb-select
                    type="select"
                    v-model="selected"
                    :options="options"
                    label="text"
                    id="value"
                    placeholder="Search Type"
                ></eb-select>
            </b-col>
            <b-col cols="12" sm="6" md="3" class="mb-3 mb-md-0 position-relative customer-field-col">
                <Vue-Simple-Suggest
                    :nullable-select="true"
                    v-model="searchInput"
                    @keyup.enter.native="searchResult()"
                    :debounce="1000"
                    display-attribute="name"
                    value-attribute="_id"
                    placeholder="Search Customer"
                ></Vue-Simple-Suggest>
                <button class="text-grey searchIcon" @click="searchResult()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
                <b-modal
                    title="Select Customer"
                    id="SimilarName"
                    size="lg"
                    ref="select-customer-name"
                    centered
                    hide-footer
                >
                    <b-row
                        class="m-1 modalOption"
                        v-for="(customer, index) in this.similarNameData"
                        :key="index"
                        :id="`customer${index}`"
                        @click="selectedCustomer(index)"
                    >
                        <b-col cols="12" sm="4" md="4" class="mb-2 mb-sm-0">
                            <h5>Full Name:</h5>
                            <span class="cust-text"
                                >{{
                                    customer && customer.name
                                        ? customer.name.first
                                        : ""
                                }}
                                {{
                                    customer && customer.name
                                        ? customer.name.last
                                        : ""
                                }}</span
                            >
                        </b-col>
                        <b-col cols="12" sm="4" md="4" class="mb-2 mb-sm-0">
                            <h5>Email:</h5>
                            <span class="cust-text">{{
                                customer && customer.authentication
                                    ? customer.authentication.email
                                    : ""
                            }}</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4">
                            <h5>Phone:</h5>
                            <span>{{
                                customer && customer.authentication
                                    ? customer.authentication.phone
                                    : ""
                            }}</span>
                        </b-col>
                    </b-row>
                </b-modal>
            </b-col>
        </b-row>
        <b-card class="cust-img-card">
            <img :src="`img/customerCare.png`" class="cust-img" />
        </b-card>
    </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
    components: {
        ebButton,
        cInput,
        VueSimpleSuggest,
        ebSelect,
    },
    data() {
        return {
            searchInput: "",
            selected: "",
            options: [
                { text: "Customer Number", value: "CUSTOMERNO" },
                { text: "Service Ticket", value: "SR" },
                { text: "Order Number", value: "ORDERNO" },
                { text: "Name", value: "" },
                { text: "Mobile Number", value: "" },
                { text: "E-mail Id", value: "" },
            ],
            similarNameData: "",
        };
    },
    methods: {
        searchResult() {
            const payload = {
                type: this.selected.value,
                keyword: this.searchInput,
            };
            this.$store
                .dispatch("customerManagement/customerByFilter", payload)
                .then((payload) => {
                    const paramsData = payload.data?.response || "";
                    if (paramsData.length == 0) {
                        throw Error("No Data Found!!");
                    }
                    if (paramsData.length > 1) {
                        this.similarNameData = paramsData;
                        this.$refs["select-customer-name"].show();
                    } else {
                        this.$router.push({
                            name: "Customer-Management-Listing",
                            params: {
                                userData: paramsData,
                                id: paramsData._id,
                            },
                        });
                    }
                })
                .catch((err) => {
                    this.$swal({
                        title: "Opps!!!!!",
                        text: err.message || "Please Enter a valid data ",
                        type: "error",
                    });
                });
        },
        selectedCustomer(index) {
            this.$router.push({
                name: "Customer-Management-Listing",
                params: {
                    userData: this.similarNameData[index],
                    id: this.similarNameData[index]?._id || "",
                },
            });
        },
    },
};
</script>

<style scoped>
.text-grey {
    color: #aaaa;
    background-color: transparent;
}

.modalOption {
    text-align: center;
    border: 1px solid #e0dfdf;
    border-radius: 10px;
}

.modalOption:hover {
    cursor: pointer;
    background-color: #f2f2f2;
}


.customer-field-col {
    display: flex;
    align-items: center;
}

::v-deep .customer-search-row .form-group {
    width: 100%;
    margin-bottom: 0;
}

::v-deep .customer-search-row .v-select .vs__dropdown-toggle {
    min-height: 40px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #cde;
    border-radius: 10px;
}

::v-deep .customer-search-row .v-select .vs__selected-options {
    padding: 0;
}

::v-deep .customer-search-row .v-select .vs__actions {
    padding-right: 2px;
}

::v-deep .customer-search-row .vue-simple-suggest {
    display: block;
    width: 100%;
}

::v-deep .customer-search-row .vue-simple-suggest input {
    height: 40px !important;
    width: 100% !important;
    padding: 0 40px 0 12px !important;
    border: 1px solid #cde;
    border-radius: 10px !important;
    color: black;
    background: white;
    outline: none;
    transition: all 0.1s;
    transition-delay: 0.05s;
}



.cust-img-card {
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cust-img {
    height: 340px;
    max-width: 100%;
    object-fit: contain;
}

.cust-text {
    word-wrap: break-word;
}

.page-title {
    margin-bottom: 0;
}

.customer-search-row {
    align-items: center;
}

.searchIcon {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    line-height: 1;
}


@media (max-width: 767.98px) {
    .cust-img-card {
        height: 400px;
    }

    .cust-img {
        height: 280px;
    }

    .page-title {
        font-size: 1.5rem;
    }
}

@media (max-width: 575.98px) {
    .cust-img-card {
        height: 300px;
    }

    .cust-img {
        height: 220px;
    }

    .page-title {
        font-size: 1.25rem;
    }
}
</style>
